//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Low_back_pain_surgical_scoring_criteria",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {
          value: "3",
          name: "没有",
        },
        {
          value: "2",
          name: " 时有",
        },
        {
          value: "1",
          name: "常有或有时严重",
        },
        {
          value: "0",
          name: "常很严重",
        },
      ],
      dataList2: [
        {
          value: "3",
          name: "没有",
        },
        {
          value: "2",
          name: " 时有",
        },
        {
          value: "1",
          name: "常有或有时严重",
        },
        {
          value: "0",
          name: "常很严重",
        },
      ],
      dataList3: [
        {
          value: "3",
          name: "没有",
        },
        {
          value: "2",
          name: " 时有",
        },
        {
          value: "1",
          name: "常有或有时严重",
        },
        {
          value: "0",
          name: "常很严重",
        },
      ],
      dataList4: [
        {
          value: "3",
          name: "正常",
        },
        {
          value: "2",
          name: "不能持续",
        },
        {
          value: "1",
          name: "轻度障碍",
        },
        {
          value: "0",
          name: "不能完成",
        },
      ],
      dataList5: [
        {
          value: "0",
          name: "正常",
        },
        {
          value: "-1",
          name: " 仅有无力、不适、或步行200米以后出现间歇性跛行",
        },
        {
          value: "-2",
          name: "明显的间隙性跛行",
        },
      ],
      dataList6: [
        {
          value: "3",
          name: "阴性",
        },
        {
          value: "2",
          name: "有椎旁触压轻度放射痛或直腿抬高加强试验阳性大于50度",
        },
        {
          value: "1",
          name: "腰部活动略受限，有椎旁触压放射痛，直腿抬高加强试验阳性",
        },
        {
          value: "0",
          name: "腰部活动严重受限，有放射痛，直腿抬高加强试验阳性且小于30度",
        },
      ],
      dataList7: [
        {
          value: "2",
          name: "正常",
        },
        {
          value: "1",
          name: "轻度障碍",
        },
        {
          value: "0",
          name: "明显障碍",
        },
      ],
      dataList8: [
        {
          value: "2",
          name: "正常",
        },
        {
          value: "1",
          name: "轻度减退",
        },
        {
          value: "0",
          name: "明显减退",
        },
      ],
      dataList9: [
        {
          value: "1",
          name: "正常",
        },
        {
          value: "0",
          name: "减弱或消失",
        },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Low_back_pain_surgical_scoring_criteria.vue